// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
   production: false,
   build: false,
   stage: false,
   sentryAllowed: false,
   sentryUrl : 'https://9a86553d7b0ec4e50f5fd8b13e1ee01c@o4508970504945664.ingest.de.sentry.io/4508970508353616',
   cookie: {
      domain: 'localhost',
      secure: false,
   },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
